import React from "react";
import { RegisterOptions } from "react-hook-form";
import { PrefixFormItem, PhoneField } from "..";
import { PhoneControlProps } from "./PhoneControl.types";
import { GetChildrePropsParams } from "../FormItem/FormItem.types";

function PhoneControl(props: PhoneControlProps) {
  const {
    defaultValue,
    getPhoneFieldProps,
    label,
    name,
    prefixName,
    prefixValidate,
    prefixDefaultValue,
    prefixLabel,
    required,
    validate,
    ...other
  } = props;

  const rules = React.useMemo<RegisterOptions>(() => {
    const result: RegisterOptions = {
      validate,
    };
    if (required) {
      result.required = {
        value: true,
        message: label ? `${label} is required` : "Required field",
      };
    }
    return result;
  }, [label, required, validate]);

  const prefixRules = React.useMemo<RegisterOptions>(() => {
    const result: RegisterOptions = {
      validate: prefixValidate,
    };
    if (required) {
      result.required = {
        value: true,
        message: prefixLabel ? `${prefixLabel} is required` : "Required field",
      };
    }
    return result;
  }, [prefixLabel, required, prefixValidate]);

  const getChildrenProps = React.useCallback(
    (params: GetChildrePropsParams) => {
      return getPhoneFieldProps?.(params);
    },
    [getPhoneFieldProps]
  );

  return (
    <PrefixFormItem
      defaultValue={defaultValue}
      getChildrenProps={getChildrenProps}
      name={name}
      prefixDefaultValue={prefixDefaultValue}
      prefixName={prefixName}
      prefixRules={prefixRules}
      rules={rules}
    >
      <PhoneField {...other} label={label} prefixLabel={prefixLabel} />
    </PrefixFormItem>
  );
}

export default React.memo(PhoneControl);
